"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricActionNames = exports.MetricPeriodId = exports.listEnterpriseProductAccess = exports.listUserProductAccess = exports.getControllingProductSubscription = exports.isPriceTaxable = exports.getPriceFromSubscription = exports.getTrialEligibility = exports.canUserStartTrial = exports.getProductSubscription = exports.getAllUserSubscriptions = exports.listProductAccess = exports.ProductSlugs = void 0;
__exportStar(require("./purchaseUtils"), exports);
/** All product slugs by name. */
// eslint-disable-next-line no-shadow
var ProductSlugs;
(function (ProductSlugs) {
    ProductSlugs["advancedRules"] = "advanced-rules";
    ProductSlugs["axeDevToolsHTML"] = "axe-devtools-html";
    ProductSlugs["axeDevToolsMobile"] = "axe-devtools-mobile";
    ProductSlugs["axeDevToolsExtension"] = "axe-devtools-pro";
    ProductSlugs["axeDevToolsWatcher"] = "axe-devtools-watcher";
    ProductSlugs["axeLinter"] = "axe-devtools-linter";
    ProductSlugs["axeReports"] = "axe-reports";
    ProductSlugs["axeMonitor"] = "axe-monitor";
    ProductSlugs["axeAuditor"] = "axe-auditor";
    ProductSlugs["dequeUniversity"] = "deque-university";
    ProductSlugs["axeSpider"] = "axe-spider";
    ProductSlugs["jiraIntegration"] = "jira-integration";
    ProductSlugs["jiraOnPremIntegration"] = "jira-on-prem-integration";
    ProductSlugs["jiraDirectCloudIntegration"] = "jira-direct-cloud-integration";
    ProductSlugs["axeAuditorIntegration"] = "axe-auditor-integration";
    ProductSlugs["customIntegration"] = "custom-integration";
    ProductSlugs["axeAssistantSlack"] = "axe-assistant-slack";
    ProductSlugs["axeAssistantTeams"] = "axe-assistant-teams";
    ProductSlugs["scimService"] = "scim-service";
    ProductSlugs["axeMCPServer"] = "axe-mcp-server";
})(ProductSlugs || (exports.ProductSlugs = ProductSlugs = {}));
/** Default all purchase states to `none`. */
const DEFAULT_PURCHASE_STATE = 'none';
/** Default all product access. */
const DEFAULT_PRODUCT_ACCESS = {
    [ProductSlugs.advancedRules]: DEFAULT_PURCHASE_STATE,
    [ProductSlugs.axeDevToolsHTML]: DEFAULT_PURCHASE_STATE,
    [ProductSlugs.axeDevToolsMobile]: DEFAULT_PURCHASE_STATE,
    [ProductSlugs.axeDevToolsExtension]: DEFAULT_PURCHASE_STATE,
    [ProductSlugs.axeDevToolsWatcher]: DEFAULT_PURCHASE_STATE,
    [ProductSlugs.axeLinter]: DEFAULT_PURCHASE_STATE,
    [ProductSlugs.axeReports]: DEFAULT_PURCHASE_STATE,
    [ProductSlugs.axeMonitor]: DEFAULT_PURCHASE_STATE,
    [ProductSlugs.axeAuditor]: DEFAULT_PURCHASE_STATE,
    [ProductSlugs.dequeUniversity]: DEFAULT_PURCHASE_STATE,
    [ProductSlugs.axeSpider]: DEFAULT_PURCHASE_STATE,
    [ProductSlugs.jiraIntegration]: DEFAULT_PURCHASE_STATE,
    [ProductSlugs.jiraOnPremIntegration]: DEFAULT_PURCHASE_STATE,
    [ProductSlugs.jiraDirectCloudIntegration]: DEFAULT_PURCHASE_STATE,
    [ProductSlugs.axeAuditorIntegration]: DEFAULT_PURCHASE_STATE,
    [ProductSlugs.customIntegration]: DEFAULT_PURCHASE_STATE,
    [ProductSlugs.axeAssistantSlack]: DEFAULT_PURCHASE_STATE,
    [ProductSlugs.axeAssistantTeams]: DEFAULT_PURCHASE_STATE,
    [ProductSlugs.scimService]: DEFAULT_PURCHASE_STATE,
    [ProductSlugs.axeMCPServer]: DEFAULT_PURCHASE_STATE
};
/** Weighted purchase states. */
const purchaseStateLevels = {
    none: 1,
    free: 2,
    free_payment_failed: 3,
    trial_ended: 4,
    trial_payment_failed: 5,
    paid_payment_failed: 6,
    trialing: 7,
    paid: 8
};
/**
 * Get a list of product access based on the given `subscriptions`.
 *
 * @deprecated This function is now deprecated; use `listUserProductAccess` or `listEnterpriseProductAccess` instead.
 */
const listProductAccess = (subscriptions) => {
    if (!Array.isArray(subscriptions)) {
        throw new TypeError('`subscriptions` must be an array');
    }
    // Default each product to `none`. These _may_ be overridden below.
    const access = { ...DEFAULT_PRODUCT_ACCESS };
    // Find the "highest" purchase state for each product.
    for (const subscription of subscriptions) {
        const state = subscription.purchase_state;
        const slug = subscription.product_slug;
        const existingState = access[slug];
        const existingLevel = purchaseStateLevels[existingState];
        const newLevel = purchaseStateLevels[state];
        // If the slug is not known, just set the state and move on.
        if (!existingState) {
            access[slug] = state;
            continue;
        }
        // If the new state is "higher" than the existing state, replace it.
        if (newLevel > existingLevel) {
            access[slug] = state;
        }
    }
    // The axe DevTools HTML bundle implicitly includes Pro. Take the "highest" state of each.
    if (access[ProductSlugs.axeDevToolsHTML] !== DEFAULT_PURCHASE_STATE) {
        const html = purchaseStateLevels[access[ProductSlugs.axeDevToolsHTML]];
        const pro = purchaseStateLevels[access[ProductSlugs.axeDevToolsExtension]];
        if (pro < html) {
            access[ProductSlugs.axeDevToolsExtension] =
                access[ProductSlugs.axeDevToolsHTML];
        }
    }
    return access;
};
exports.listProductAccess = listProductAccess;
/** Get all (personal and enterprise) subscriptions a `user` has. */
const getAllUserSubscriptions = (user) => [
    ...user.subscriptions,
    ...user.enterprises.flatMap(enterprise => enterprise.subscriptions)
];
exports.getAllUserSubscriptions = getAllUserSubscriptions;
/* get product subscription by product slug for a user or enterprise */
function getProductSubscription(subscriptions, slug) {
    if (slug === ProductSlugs.axeDevToolsExtension) {
        const html = subscriptions.find(s => s.product_slug === ProductSlugs.axeDevToolsHTML);
        const pro = subscriptions.find(s => s.product_slug === ProductSlugs.axeDevToolsExtension);
        // When the user has both a Pro and HTML subscription, return the subscription with the "highest" purchase state.
        if (html && pro) {
            const htmlLevel = purchaseStateLevels[html.purchase_state];
            const proLevel = purchaseStateLevels[pro.purchase_state];
            if (htmlLevel > proLevel) {
                return html;
            }
            return pro;
        }
        return pro || html || null;
    }
    return subscriptions.find(s => s.product_slug === slug) || null;
}
exports.getProductSubscription = getProductSubscription;
/**
 * @deprecated This function is now deprecated.
 *
 * Use `canUserStartTrialV2` instead.
 */
const canUserStartTrial = ({ user, productSlug, enterprise, isEnterpriseAdmin = false }) => {
    if (enterprise) {
        const enterpriseProductAccess = (0, exports.listProductAccess)(enterprise.subscriptions);
        return enterpriseProductAccess[productSlug] === 'none' && isEnterpriseAdmin;
    }
    const userProductAccess = (0, exports.listProductAccess)(user.subscriptions);
    return userProductAccess[productSlug] === 'none';
};
exports.canUserStartTrial = canUserStartTrial;
/**
 * Return an object with two fields
 * canStartTrial - indicates whether trial can be started, either first trial or restart of a trial
 * isRestart (can only be true if canStartTrial is true) - indicates whether trial is a restart an not the first one
 *
 * @param user - billing user that will be checked for trial availability for non enterprise users
 * @param product - product that we want to check whether we can start the trial on
 * @param enterprise - enterprise that will be checked for trial availability for a user or null when non enterprise user
 * @param isEnterpriseAdmin - boolean indicating whether user is an admin in the provided enterprise or null when non enterprise user
 * @returns object indicating whether trial can be started and if so, whether it would be a restart (not a first trial)
 */
const getTrialEligibility = ({ user, product, enterprise, isEnterpriseAdmin = false }) => {
    // Only Enterprise Admin can start trial for any product
    if (enterprise && !isEnterpriseAdmin) {
        return { canStartTrial: false, isRestart: false };
    }
    const productSlug = product.slug;
    // Get current access to this product
    let currentProductSubscription;
    if (enterprise) {
        currentProductSubscription = (0, exports.getControllingProductSubscription)(enterprise, productSlug);
    }
    else {
        currentProductSubscription = (0, exports.getControllingProductSubscription)(user, productSlug);
    }
    // If we do not have any subscription info, treat it as "none" and allow to start new subscription
    if (currentProductSubscription === null) {
        return { canStartTrial: true, isRestart: false };
    }
    // If current subscription is managed by the Stripe, then re-trial is not allowed.
    // User must first downgrade (remove Stripe linkage) before being considered for a retrial
    if (currentProductSubscription.stripe_id) {
        return { canStartTrial: false, isRestart: false };
    }
    const currentPurchaseState = currentProductSubscription.purchase_state;
    // If user has had subscription, but not a trial (moat likely they purchased it earlier), they can always start their first trial
    if (currentPurchaseState !== 'paid' &&
        !currentProductSubscription.trial_expires) {
        return { canStartTrial: true, isRestart: false };
    }
    // Trial can be restarted if we are not already in trial or have paid subscription
    if (currentPurchaseState !== 'trialing' && currentPurchaseState !== 'paid') {
        // Check that required data is not null
        if (currentProductSubscription.trial_expires !== null &&
            product.reactivate_trial_cutoff !== null) {
            // And that expiration for current (or previous) trial is before trial cutoff date
            const canRestart = new Date(currentProductSubscription.trial_expires) <
                new Date(product.reactivate_trial_cutoff);
            return { canStartTrial: canRestart, isRestart: canRestart };
        }
    }
    return { canStartTrial: false, isRestart: false };
};
exports.getTrialEligibility = getTrialEligibility;
/**
 * Retrieve a Stripe price object from a subscription object.
 */
const getPriceFromSubscription = (subscription) => {
    return subscription.items.data[0].price;
};
exports.getPriceFromSubscription = getPriceFromSubscription;
/**
 * Determine whether a price used for a subscription is taxable or not.
 */
const isPriceTaxable = (price) => {
    return !!(price.metadata.taxable && price.metadata.taxable === 'true');
};
exports.isPriceTaxable = isPriceTaxable;
/**
 * **Note: The returned subscription's `product_slug` may differ from the `productSlug`
 * parameter if the user has access via a bundle subscription.**
 *
 * When provided a `v2.User` get the subscription which currently controls a user's access to a product, if any.
 * If the user is associated with an enterprise, only enterprise subscriptions will be considered.
 *
 * When provided a `v2.Enterprise` get the subscription which the enterprise currently has.
 * This may be a subscription a `v2.User` may or may not have access to. Consider providing a `v2.User` to get the controlling subscription for a user.
 *
 * @param entity Billing entity to retrieve a product subscription for
 * @param productSlug The product slug to find the subscription for
 * @returns Subscription | null
 */
const getControllingProductSubscription = (entity, productSlug) => {
    const getSubscription = (subscriptions) => {
        // No need to continue if there are no subscriptions
        if (!subscriptions.length) {
            return null;
        }
        const subscription = 
        // Check for a bundled subscription first
        getBundledSubscription(subscriptions, productSlug) ||
            // If no bundled subscription, check for a standalone subscription
            subscriptions.find(s => s.product_slug === productSlug);
        if (!subscription) {
            return null;
        }
        return subscription;
    };
    /**
     * If the user is part of an enterprise, prioritize the enterprise
     * subscriptions the user has been granted access to.
     * Otherwise, use the user's personal subscriptions.
     */
    if ('keycloak_id' in entity) {
        return entity.enterprises.length
            ? getSubscription(entity.enterprises.flatMap(e => e.subscriptions))
            : getSubscription(entity.subscriptions);
    }
    /**
     * We have been given an enterprise, attempt to
     * find the enterprise subscription for the product.
     */
    return getSubscription(entity.subscriptions);
};
exports.getControllingProductSubscription = getControllingProductSubscription;
/**
 * Get a bundled subscription if it exists.
 *
 * @param subscriptions List of subscriptions to check
 * @returns Subscription | null
 */
const getBundledSubscription = (subscriptions, productSlug) => {
    if (productSlug !== ProductSlugs.axeDevToolsExtension) {
        return null;
    }
    const html = subscriptions.find(s => s.product_slug === ProductSlugs.axeDevToolsHTML);
    const pro = subscriptions.find(s => s.product_slug === ProductSlugs.axeDevToolsExtension);
    // When the user has both a Pro and HTML subscription, return the subscription with the "highest" purchase state.
    if (html && pro) {
        const htmlLevel = purchaseStateLevels[html.purchase_state];
        const proLevel = purchaseStateLevels[pro.purchase_state];
        if (htmlLevel > proLevel) {
            return html;
        }
        return pro;
    }
    return pro || html || null;
};
/**
 * A helper function to generate a list of product access based on the given `v2.User` or `v2.Enterprise`.
 */
const generateProductAccess = (entity) => {
    // Default each product to `none`. These _may_ be overridden below.
    const productAccess = structuredClone(DEFAULT_PRODUCT_ACCESS);
    for (const productSlug of Object.values(ProductSlugs)) {
        const subscription = (0, exports.getControllingProductSubscription)(entity, productSlug);
        if (!subscription) {
            continue;
        }
        productAccess[productSlug] = subscription.purchase_state;
    }
    return productAccess;
};
/**
 * Get a read-only record of product slugs a `v2.User` has access to and the purchase state.
 *
 * @param user - The billing user to get product access for
 * @returns A readonly record of product slugs and their purchase states
 */
const listUserProductAccess = (user) => {
    return generateProductAccess(user);
};
exports.listUserProductAccess = listUserProductAccess;
/**
 * Get a read-only record of product slugs an `v2.Enterprise` has access to and their purchase states.
 *
 * @param enterprise - The billing enterprise  to get product access for
 * @returns A readonly record of product slugs and their purchase states
 */
const listEnterpriseProductAccess = (enterprise) => {
    return generateProductAccess(enterprise);
};
exports.listEnterpriseProductAccess = listEnterpriseProductAccess;
var MetricPeriodId;
(function (MetricPeriodId) {
    MetricPeriodId["calendarMonthly"] = "calendar-monthly";
    MetricPeriodId["calendarAnnual"] = "calendar-annual";
    MetricPeriodId["billingMonthly"] = "billing-monthly";
})(MetricPeriodId || (exports.MetricPeriodId = MetricPeriodId = {}));
var MetricActionNames;
(function (MetricActionNames) {
    MetricActionNames["sendIssue"] = "send issue";
})(MetricActionNames || (exports.MetricActionNames = MetricActionNames = {}));
//# sourceMappingURL=utils.js.map